import {
	AboutUsRoute,
	BecomeAPartnerRoute,
	GiveawayDetailsRoute,
	GiveawaysRoute,
	HomeRoute,
	WinnersRoute,
} from "@/features/home/route";
import {
	ProfileCurrentEntriesRoute,
	ProfileDashboardRoute,
	ProfileManageMembershipRoute,
	ProfileMembershipDiscountsRoute,
	ProfilePurchaseHistoryRoute,
	ProfileSettingsRoute,
} from "@/features/profile/route";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BodyBackground: React.FC = () => {
	const location = useLocation();

	useEffect(() => {
		const pageBackgrounds: Record<string, string> = {
			// Main Pages Backgrounds
			[HomeRoute]: "bg-blue",
			[AboutUsRoute]: "bg-blue",
			[WinnersRoute]: "bg-blue",
			[BecomeAPartnerRoute]: "bg-blue",

			// Giveaways Backgrounds
			[GiveawaysRoute]: "bg-blue",
			[GiveawayDetailsRoute]: "bg-blue",

			// Profile Backgrounds
			[ProfileDashboardRoute]: "bg-blue",
			[ProfileSettingsRoute]: "bg-blue",
			[ProfileManageMembershipRoute]: "bg-blue",
			[ProfilePurchaseHistoryRoute]: "bg-blue",
			[ProfileMembershipDiscountsRoute]: "bg-blue",
			[ProfileCurrentEntriesRoute]: "bg-blue",
		};

		document.body.className = pageBackgrounds[location.pathname] || "bg-white";

		return () => {
			document.body.className = "";
		};
	}, [location.pathname]);

	return null;
};

export default BodyBackground;
